import { SelectedVisit } from '@types';
import dayjs from 'dayjs';

export type RescheduleReason =
  | 'dateTimeNotAvailable'
  | 'userInitiated'
  | 'rescheduleVisit';
export function getRescheduleUrl(
  visit: SelectedVisit,
  reason: RescheduleReason,
): string {
  return `/reschedule/${visit.visitTypeId}?date=${visit.date}&reason=${reason}`;
}

export function getVisitTypeUrl(
  visitTypeId: string,
  date?: string | null,
): string {
  return `/schedule/${visitTypeId}?date=${date || dayjs().format('YYYY-MM-DD')}`;
}

export function getVisitTypeListUrl(
  serviceTypeId: string,
  state: string,
): string {
  return `/services/${serviceTypeId}?state=${state}`;
}
export function getVisitTypeUrlForPatient(visitTypeId: string): string {
  return `/schedule/${visitTypeId}`;
}
